/* eslint-disable no-var */
// /stores, "Fleek around the world": every store with a home of its own,
// India's (/) and each country store's (/us, /ae, …), with what it sells.
//
// Shared by the prerender (which knows each store's catalogue: brand counts,
// categories, best discount) and the React page (which falls back to the list
// of stores alone), so both say the same thing. A crawlable page that links
// every store home, and the target of the footer's "Stores" link.
//
// CommonJS on purpose, like brandPage.js: Node requires it at build time.

var brandPage = require('./brandPage');
var countryStores = require('./country-stores.json');

var SITE_URL = brandPage.SITE_URL;

// 🇬🇧 from GB: two regional-indicator letters.
var flagOf = function (code) {
  return String.fromCodePoint.apply(
    null,
    String(code)
      .toUpperCase()
      .split('')
      .map(function (c) {
        return 0x1f1a5 + c.charCodeAt(0);
      })
  );
};

// "United States", "Germany": the country's own name, for a card.
var countryName = function (code) {
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(code) || code;
  } catch (e) {
    return code;
  }
};

/**
 * One card per store: India first, then the country stores by name.
 *
 * `stores` is optional detail from the prerender, keyed by code ("IN", "US"):
 * { count, categories: [names], maxPct, currency }. Without it a card names the store
 * and its currency only, never a number it doesn't know.
 */
var buildStoresPage = function (options) {
  var opts = options || {};
  var siteUrl = (opts.siteUrl || SITE_URL).replace(/\/$/, '');
  var detail = opts.stores || {};
  // opts.countries: the stores with a home this build (the prerender's);
  // without it, every store in src/seo/country-stores.json.
  var listed = Array.isArray(opts.countries) ? opts.countries : countryStores.countries;
  var codes = ['IN'].concat(
    listed.slice().sort(function (a, b) {
      return countryName(a).localeCompare(countryName(b));
    })
  );
  var cards = codes.map(function (code) {
    var d = detail[code] || {};
    var india = code === 'IN';
    return {
      country: code,
      name: countryName(code),
      flag: flagOf(code),
      // The store's own currency when the prerender saw its prices (a store
      // switched to euros says EUR), else rupees in India and dollars elsewhere.
      currency: /^[A-Za-z]{3}$/.test(String(d.currency || '')) ? String(d.currency).toUpperCase() : india ? 'INR' : 'USD',
      href: india ? '/' : brandPage.countryPath(code),
      count: Number(d.count) > 0 ? Math.round(Number(d.count)) : 0,
      categories: (d.categories || []).slice(0, 3),
      maxPct: Math.round(Number(d.maxPct) || 0),
    };
  });
  var total = cards.length;
  var url = siteUrl + '/stores';
  var heading = 'Fleek around the world';
  var title = 'Fleek stores in ' + total + ' countries: subscriptions and gift cards | Fleek';
  var description =
    'Fleek has a store for ' + total + ' countries, each with its own catalogue and prices: ' +
    cards
      .slice(0, 4)
      .map(function (c) {
        return c.name;
      })
      .join(', ') +
    ' and more. Shopping from somewhere else? You get the global store, in USD.';

  var jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        '@id': url + '#page',
        name: heading,
        url: url,
        mainEntity: {
          '@type': 'ItemList',
          numberOfItems: total,
          itemListElement: cards.map(function (c, i) {
            return { '@type': 'ListItem', position: i + 1, name: 'Fleek ' + c.name, url: siteUrl + (c.href === '/' ? '/' : c.href) };
          }),
        },
      },
    ],
  };

  return { url: url, heading: heading, title: title, description: description, cards: cards, jsonLd: jsonLd };
};

module.exports = { buildStoresPage: buildStoresPage, flagOf: flagOf };
